module.exports = __webpack_public_path__ + "media/about/wali-rahman-a411e2ad.jpg";